import React from 'react';
import styled from 'styled-components';

import {
  Table,
  TableCell,
  TableRow,
  TableHeaderCell,
  TextLink,
  Type,
} from '@spotify-internal/encore-creator-web';
import { gray10 } from '@spotify-internal/encore-foundation';

import { DialogBodyProps } from '../../types';
import { DialogWrapper } from '../DialogWrapper';
import { musicReliefOrgDisplayNames } from '../../lib/constants';

const TextLinkColorGray10 = styled(TextLink)`
  svg {
    color: ${gray10};
  }
`;

export function FormReview(props: DialogBodyProps) {
  const orgValue = props.org.value;

  const orgDisplayName = orgValue && musicReliefOrgDisplayNames[orgValue];

  const previewLinkUrl = props.link.value;

  const previewLinkDisplayText = orgDisplayName || previewLinkUrl;

  return (
    <DialogWrapper>
      <Table>
        <colgroup>
          <col />
        </colgroup>
        <thead>
          <TableRow>
            <TableHeaderCell>Fundraising link</TableHeaderCell>
          </TableRow>
        </thead>
        <tbody>
          <TableRow>
            <TableCell>
              <TextLinkColorGray10
                id="preview-link"
                href={previewLinkUrl}
                target="preview"
                external
              >
                <label htmlFor="preview-link" style={{ cursor: 'pointer' }}>
                  <Type variant={Type.body1} color={gray10}>
                    {previewLinkDisplayText}
                  </Type>
                </label>
              </TextLinkColorGray10>
            </TableCell>
          </TableRow>
        </tbody>
      </Table>
    </DialogWrapper>
  );
}
